function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
import { SearchBarNews, useWindowDimensions } from '../SearchBarNews';
import { DesktopMenuNews } from '../DesktopMenuNews';
import { MobileMenuNews } from '../MobileMenuNews';
import { AgroHeaderContext } from '../../contexts/AgroHeaderContext';
import { AgroHamburgerButton } from '../../atoms/AgroHamburgerButton';
import { UserWrapperNews } from '../UserWrapperNews';
import { IhamburgerMenu } from '../../atoms/AgroIcon/icons';
import { AgroSpinner } from '../../atoms/AgroSpinner';
import { getMenu } from './getMenu';
import { getHeaderButtons } from '../Header/getHeaderButtons';
import { buildNotifications } from '../Header/buildNotifications';
import { LogoContainer, HamburgerButtonContainer, HeaderTagStyled, HeaderContainer, MainHeader, MenuContainer, AgrofyLogo, AgrofyNewsLogoFull, LeftContent, MobileSpinnerContainer, CategoriesContainer, CategoriesButton, CategoriesItem, LoadingContainer, Loading, CategoriesButtonContainer, CategoriesItemContainer, LocationLoaderContainer, CategoriesLoaderContainer, CategoriesBar, GeoContainer, UserWrapperContainer, ItemLink } from './StyledHeader';
import { WeatherFieldZone } from '../WeatherFieldZone';
import { getUserAddress, setUserAddress, updateOfflineUserDataWeather, getOfflineUserDataEmail, getOfflineUserData, getOfflineWeatherData } from '../../services/userAddress';
export function getWindowDimensions() {
  if (typeof window !== 'undefined') {
    var _window = window,
      width = _window.innerWidth,
      height = _window.innerHeight;
    return {
      width: width,
      height: height
    };
  }
}
export function useIsSmallScreen() {
  var _useState = useState(getWindowDimensions()),
    _useState2 = _slicedToArray(_useState, 2),
    windowDimensions = _useState2[0],
    setWindowDimensions = _useState2[1];
  useEffect(function () {
    if (typeof window !== 'undefined') {
      var handleResize = function handleResize() {
        setWindowDimensions(getWindowDimensions());
      };
      window.addEventListener('resize', handleResize);
      return function () {
        return window.removeEventListener('resize', handleResize);
      };
    }
  }, []);
  return typeof windowDimensions !== 'undefined' ? windowDimensions.width < 1201 : false;
}
var HeaderNews = withCssProps(function () {
  var _useContext = useContext(AgroHeaderContext),
    baseUrl = _useContext.baseUrl,
    marketUrl = _useContext.marketUrl,
    loginUrlRedirect = _useContext.loginUrlRedirect,
    translations = _useContext.translations,
    tagManager = _useContext.tagManager,
    apiGateway = _useContext.apiGateway,
    notifications = _useContext.notifications,
    loadingUser = _useContext.loadingUser,
    loadingNotifications = _useContext.loadingNotifications,
    location = _useContext.location,
    _onClick = _useContext.onClick,
    menuSection = _useContext.menuSection,
    urlMenuService = _useContext.urlMenuService,
    urlSearchService = _useContext.urlSearchService,
    language = _useContext.language,
    user = _useContext.user,
    urlPrefix = _useContext.urlPrefix,
    popoverDisabled = _useContext.popoverDisabled,
    variant = _useContext.variant,
    setAccountMenu = _useContext.setAccountMenu,
    onLastLocationChanged = _useContext.onLastLocationChanged,
    resetClasifyItems = _useContext.resetClasifyItems,
    sessionItem = _useContext.sessionItem,
    setSessionItem = _useContext.setSessionItem,
    lastLocation = _useContext.lastLocation,
    mainMenuUrl = _useContext.mainMenuUrl,
    mainMenuVersion = _useContext.mainMenuVersion,
    pageId = _useContext.pageId,
    ctaCurrentLocationLabelModal = _useContext.ctaCurrentLocationLabelModal,
    openLocationModal = _useContext.openLocationModal,
    onLocationModalClose = _useContext.onLocationModalClose;
  var isMobile = useWindowDimensions();
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isOpenMenu = _useState4[0],
    setIsOpenMenu = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isFocus = _useState6[0],
    setIsFocus = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isLoadingMenu = _useState8[0],
    setIsLoadingMenu = _useState8[1];
  var _useState9 = useState(true),
    _useState0 = _slicedToArray(_useState9, 2),
    firstOpenMenu = _useState0[0],
    setFirstOpenMenu = _useState0[1];
  var _useState1 = useState([]),
    _useState10 = _slicedToArray(_useState1, 2),
    bookmarkMenu = _useState10[0],
    setBookmarkMenu = _useState10[1];
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    itemsMenuDesktop = _useState12[0],
    setItemsMenuDesktop = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    itemsMenuMobile = _useState14[0],
    setItemsMenuMobile = _useState14[1];
  var _useState15 = useState({}),
    _useState16 = _slicedToArray(_useState15, 2),
    notificationsBuilt = _useState16[0],
    setNotificationsBuilt = _useState16[1];
  var _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2),
    headerButtons = _useState18[0],
    setHeaderButtons = _useState18[1];
  var _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    resultsOther = _useState20[0],
    setResultsOther = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    loading = _useState22[0],
    setLoading = _useState22[1];
  var _useState23 = useState(null),
    _useState24 = _slicedToArray(_useState23, 2),
    address = _useState24[0],
    setAddress = _useState24[1];
  var _useState25 = useState(undefined),
    _useState26 = _slicedToArray(_useState25, 2),
    isDifferentAddress = _useState26[0],
    setIsDifferentAddress = _useState26[1];
  var _useState27 = useState(true),
    _useState28 = _slicedToArray(_useState27, 2),
    canUseCallback = _useState28[0],
    setCanUseCallback = _useState28[1];
  var _useState29 = useState(false),
    _useState30 = _slicedToArray(_useState29, 2),
    userAddressLoaded = _useState30[0],
    setUserAddressLoaded = _useState30[1];
  var _useState31 = useState(null),
    _useState32 = _slicedToArray(_useState31, 2),
    weatherLocation = _useState32[0],
    setWeatherLocation = _useState32[1];
  var country = {
    'es-AR': 'argentina',
    'es-BO': 'bolivia',
    'es-CL': 'chile',
    'es-CO': 'colombia',
    'es-PE': 'peru',
    'es-PY': 'paraguay',
    'es-UY': 'uruguay',
    'pt-BR': 'brasil'
  };
  var functionSort = function functionSort(s) {
    s.sort(function (a, b) {
      if (a.Score < b.Score) {
        return 1;
      }
      if (a.Score > b.Score) {
        return -1;
      }
      if (a.Suggestion < b.Suggestion) {
        return 1;
      }
      if (a.Suggestion > b.Suggestion) {
        return -1;
      }
      return 0;
    });
    return s;
  };
  var newAddressSelected = function newAddressSelected(newAddress) {
    var _window$location;
    if (!!user) {
      setUserAddress(false, newAddress, baseUrl + urlPrefix);
    } else if (!!getOfflineUserDataEmail()) {
      setUserAddress(true, newAddress, baseUrl + urlPrefix);
    }
    setIsDifferentAddress(false);
    setAddress(updateOfflineUserDataWeather(newAddress, "cookie"));
    setCanUseCallback(true);
    (_window$location = window.location) === null || _window$location === void 0 || _window$location.reload();
  };
  useEffect(function () {
    getDataLocation();
  }, [user]);

  //Si el usuario está en nulo mostramos cargando
  //Cuando hay un cambio lo mostramos

  var formatWeatherSaved = function formatWeatherSaved(data) {
    var location = data.locationName.split(',');
    var latitude = data.coordinates ? JSON.parse(data.coordinates).lat : null;
    var longitude = data.coordinates ? JSON.parse(data.coordinates).lng : null;
    return {
      City: data.name,
      Country: location[location.length - 1].trim(),
      Department: "",
      State: data.locationName,
      ZipCode: "",
      Latitude: latitude,
      Longitude: longitude
    };
  };
  var getDataLocation = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var locationCookie, _location, _location2;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            locationCookie = getOfflineWeatherData(false);
            if (locationCookie) {
              if (locationCookie.saved) {
                _location = formatWeatherSaved(locationCookie.saved);
                _location.type = "saved";
                setAddress(_location);
              } else if (locationCookie.cookie) {
                _location2 = locationCookie.cookie;
                _location2.type = "cookie";
                setAddress(_location2);
              } else {
                setAddress(null);
              }
            }
            setCanUseCallback(true);
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function getDataLocation() {
      return _ref.apply(this, arguments);
    };
  }();
  useEffect(function () {
    if (!address || !address.City || !address.State) return;
    if (onLastLocationChanged && canUseCallback) {
      onLastLocationChanged(address);
    }
    setIsDifferentAddress(compareAddresses(address));
  }, [address]);
  var compareAddresses = function compareAddresses(address) {
    var addressToCompareWith = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var lsData = addressToCompareWith ? addressToCompareWith : getOfflineWeatherData();
    var areDifferent = false;
    if (address && lsData) {
      areDifferent = !(address.City == lsData.City && address.State === lsData.State);
    }
    return areDifferent;
  };
  useEffect(function () {
    notifications && Object.keys(notifications).length && setNotificationsBuilt(buildNotifications(notifications, translations));
    if (firstOpenMenu) {
      setIsLoadingMenu(true);
      getMenu(urlMenuService, menuSection).then(function (data) {
        var _data$mobile, _data$mobile2, _data$bookmark;
        setSessionItem(data === null || data === void 0 || (_data$mobile = data.mobile) === null || _data$mobile === void 0 ? void 0 : _data$mobile.find(function (item) {
          return ['Cerrar Sesión', 'Cerrar sesión', 'Fechar Sessão', 'Fechar sessão', 'Sair'].includes(item.Name);
        }));
        setAccountMenu(data === null || data === void 0 || (_data$mobile2 = data.mobile) === null || _data$mobile2 === void 0 ? void 0 : _data$mobile2.find(function (item) {
          return ['Mi Cuenta', 'Minha conta', 'Mi cuenta', 'Minha Conta'].includes(item.Name);
        }));
        var menuPrincipal = [];
        data.destacado.map(function (item) {
          menuPrincipal.push({
            "name": item.Name,
            "url": item.URL
          });
        });
        setResultsOther(menuPrincipal);
        setBookmarkMenu(((_data$bookmark = data.bookmark) === null || _data$bookmark === void 0 ? void 0 : _data$bookmark.pop()) || null);
        setItemsMenuDesktop(data.desktop);
        setItemsMenuMobile(data.mobile.map(function (item) {
          if (item.URL === '/login') {
            item.URL = "/auth?urlRedirect=".concat(loginUrlRedirect || baseUrl);
          }
          return item;
        }));
        setFirstOpenMenu(false);
      })["catch"](function (error) {
        console.error(error);
      })["finally"](function () {
        setIsLoadingMenu(false);
      });
    }
  }, [urlMenuService, menuSection, firstOpenMenu, notifications]);
  useEffect(function () {
    if (lastLocation) {
      setAddress(lastLocation);
      setCanUseCallback(false);
    }
  }, [lastLocation]);
  var openMenu = function openMenu() {
    setIsOpenMenu(true);
    document.addEventListener('click', _handleClickOutside, true);
    document.body.style.top = "-".concat(window.scrollY, "px");
    document.body.style.width = '100%';
    document.body.style.position = 'fixed';
  };
  var closeMenu = function closeMenu() {
    var scrollY = document.body.style.top;
    resetClasifyItems();
    setIsOpenMenu(false);
    document.body.style.position = '';
    document.body.style.paddingRight = '';
    document.body.style.top = '';
    document.body.style.width = '';
    // eslint-disable-next-line radix
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
  };
  var _handleClickOutside = function handleClickOutside(event) {
    var external = [];
    var ids = ['menu-container', 'menu-button-desktop', 'menu-button-mobile'];
    ids.map(function (id) {
      var el = document.getElementById(id);
      return el ? external.push(el) : null;
    });
    if (external && !external.find(function (x) {
      return x && x.contains(event.target);
    })) {
      closeMenu();
      document.removeEventListener('click', _handleClickOutside, true);
    }
  };
  var handleLinkClick = function handleLinkClick(text) {
    if (tagManager) {
      var tagManagerArgs = {
        dataLayer: {
          event: 'trackEvent',
          eventCategory: 'Navigation',
          eventAction: 'Agrofy News-Menu Header',
          eventLabel: "".concat(text)
        }
      };
      tagManager(tagManagerArgs);
    }
  };
  var showTranslation = function showTranslation(translation) {
    return translations[translation];
  };
  return /*#__PURE__*/React.createElement(HeaderTagStyled, null, /*#__PURE__*/React.createElement(HeaderContainer, {
    isFocus: isFocus
  }, /*#__PURE__*/React.createElement(MainHeader, null, /*#__PURE__*/React.createElement(LeftContent, null, (!isFocus || !isMobile) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LogoContainer, null, /*#__PURE__*/React.createElement("a", {
    href: baseUrl,
    onMouseDown: function onMouseDown() {
      return handleLinkClick('Agrofy');
    }
  }, /*#__PURE__*/React.createElement(AgrofyNewsLogoFull, {
    width: "152px",
    height: "100%"
  }), /*#__PURE__*/React.createElement(AgrofyLogo, {
    width: "32px",
    height: "32px",
    fill: "white"
  })))), /*#__PURE__*/React.createElement(SearchBarNews, {
    clickCallback: function clickCallback() {
      return setIsFocus(!isFocus);
    },
    isFocus: isMobile && isFocus
  })), (!isFocus || !isMobile) && /*#__PURE__*/React.createElement(UserWrapperContainer, null, /*#__PURE__*/React.createElement(UserWrapperNews, {
    marketUrl: marketUrl,
    notifications: notificationsBuilt,
    loadingUser: loadingUser,
    loadingNotifications: loadingNotifications,
    buttons: headerButtons.buttons,
    tagManager: tagManager
  }), /*#__PURE__*/React.createElement(HamburgerButtonContainer, null, /*#__PURE__*/React.createElement(AgroHamburgerButton, {
    onClick: function onClick(e) {
      if (_onClick) {
        _onClick(e);
      }
      !isOpenMenu ? openMenu() : closeMenu();
    },
    isActive: isOpenMenu,
    notifications: notificationsBuilt
  })))), urlPrefix === '' && useIsSmallScreen() || isMobile && !location ? /*#__PURE__*/React.createElement(React.Fragment, null) : /*#__PURE__*/React.createElement(CategoriesContainer, null, location && /*#__PURE__*/React.createElement(GeoContainer, null, urlPrefix !== '' && (!!loadingUser && !user ? /*#__PURE__*/React.createElement(LocationLoaderContainer, null, /*#__PURE__*/React.createElement(LoadingContainer, {
    h: "14px"
  }, /*#__PURE__*/React.createElement(Loading, {
    mr: "16px",
    w: "117px",
    mb: "2px"
  })), /*#__PURE__*/React.createElement(LoadingContainer, {
    h: "14px",
    hidden: true
  }, /*#__PURE__*/React.createElement(Loading, {
    mr: "16px",
    w: "171px"
  }))) : /*#__PURE__*/React.createElement(WeatherFieldZone, {
    address: address,
    isLogged: !!user,
    language: language,
    apiGateway: apiGateway,
    changeLocation: newAddressSelected,
    popoverDisabled: popoverDisabled,
    isDifferentAddress: isDifferentAddress,
    tagManager: tagManager,
    pageId: pageId,
    openLocationModal: openLocationModal,
    ctaCurrentLocationLabelModal: ctaCurrentLocationLabelModal,
    onCloseLocationModal: function onCloseLocationModal() {
      onLocationModalClose ? onLocationModalClose() : null;
    },
    userAddressLoaded: userAddressLoaded
  }))), /*#__PURE__*/React.createElement(CategoriesBar, null, /*#__PURE__*/React.createElement(CategoriesButtonContainer, null, loading ? /*#__PURE__*/React.createElement(CategoriesLoaderContainer, null, /*#__PURE__*/React.createElement(LoadingContainer, {
    h: "24px",
    w: "30px"
  }, /*#__PURE__*/React.createElement(Loading, {
    mr: "8px"
  })), /*#__PURE__*/React.createElement(LoadingContainer, {
    h: "24px",
    w: "85px"
  }, /*#__PURE__*/React.createElement(Loading, {
    mr: "16px"
  }))) : /*#__PURE__*/React.createElement(CategoriesButton, {
    id: "menu-button-desktop",
    onClick: function onClick(e) {
      if (_onClick) {
        _onClick(e);
      }
      !isOpenMenu ? openMenu() : closeMenu();
    },
    "data-cy": "desktop-button"
  }, /*#__PURE__*/React.createElement(IhamburgerMenu, {
    height: "24px",
    width: "24px",
    fill: "gray800"
  }), /*#__PURE__*/React.createElement("a", null, translations.firstLevelMenu.sections))), /*#__PURE__*/React.createElement(CategoriesItemContainer, null, loading ? /*#__PURE__*/React.createElement(CategoriesLoaderContainer, null, /*#__PURE__*/React.createElement(LoadingContainer, {
    h: "24px",
    w: "100%"
  }, /*#__PURE__*/React.createElement(Loading, {
    ml: "16px",
    mr: "16px",
    w: "75px"
  }), /*#__PURE__*/React.createElement(Loading, {
    mr: "16px",
    w: "75px"
  }), /*#__PURE__*/React.createElement(Loading, {
    mr: "16px",
    w: "75px"
  }), /*#__PURE__*/React.createElement(Loading, {
    mr: "16px",
    w: "75px"
  }), /*#__PURE__*/React.createElement(Loading, {
    mr: "16px",
    w: "75px"
  }), /*#__PURE__*/React.createElement(Loading, {
    w: "75px"
  }))) : (location && resultsOther.length > 8 ? resultsOther.slice(0, 8) : resultsOther).map(function (element, index) {
    return /*#__PURE__*/React.createElement(CategoriesItem, {
      key: index
    }, /*#__PURE__*/React.createElement(ItemLink, {
      href: element.url,
      onMouseDown: function onMouseDown() {
        handleLinkClick("featured_category_".concat(element.name));
      }
    }, element.name));
  })))), isOpenMenu ? /*#__PURE__*/React.createElement(MenuContainer, null, /*#__PURE__*/React.createElement("div", {
    id: "menu-container",
    "data-cy": "desktop-menu"
  }, /*#__PURE__*/React.createElement(DesktopMenuNews, {
    items: itemsMenuDesktop,
    isOpen: isOpenMenu,
    isLoading: isLoadingMenu,
    bookmark: bookmarkMenu,
    tagManager: tagManager
  }), itemsMenuMobile.length ? /*#__PURE__*/React.createElement(MobileMenuNews, {
    items: itemsMenuMobile,
    isOpen: isOpenMenu,
    isLoading: isLoadingMenu,
    tagManager: tagManager,
    variant: variant
  }) : /*#__PURE__*/React.createElement(MobileSpinnerContainer, null, /*#__PURE__*/React.createElement(AgroSpinner, {
    variant: "white",
    size: "48px"
  })))) : ''));
});
HeaderNews.propTypes = {
  menuData: PropTypes.object,
  user: PropTypes.object,
  notifications: PropTypes.object,
  loadingUser: PropTypes.bool,
  loadingNotifications: PropTypes.bool,
  onLastLocationChanged: PropTypes.func,
  lastLocation: PropTypes.object,
  pageId: PropTypes.string,
  ctaCurrentLocationLabelModal: PropTypes.string,
  openLocationModal: PropTypes.object,
  onLocationModalClose: PropTypes.func
};
HeaderNews.displayName = 'Header';
export { HeaderNews };